import React, { useEffect, useState } from "react";
import { api } from "../../api/client";
import { MOBILE } from "../../constants/testIds";

export default function Week() {
    const [days, setDays] = useState([]);
    const [entries, setEntries] = useState([]);

    useEffect(() => {
        api.get("/v1/assignments/week").then((r) => setDays(r.data.days || []));
        api.get("/v1/time-entries/mine").then((r) => setEntries((r.data || []).filter((e) => e.end_time)));
    }, []);

    const total = days.reduce((s, d) => s + (d.hours || 0), 0);
    const max = Math.max(1, ...days.map((d) => d.hours || 0));
    const todayIso = new Date().toLocaleDateString("en-CA", { timeZone: "Australia/Brisbane" });

    return (
        <div data-testid={MOBILE.weekRoot} className="px-5 pb-32">
            <div className="km-card p-5 mt-2">
                <div className="eyebrow">This week</div>
                <div className="flex items-baseline gap-2 mt-1">
                    <span className="num text-5xl font-extrabold tracking-[-0.03em]">{total.toFixed(1)}</span>
                    <span className="text-muted text-sm">hrs</span>
                </div>
                <div className="mt-6 flex items-end gap-2 h-32">
                    {days.map((d) => {
                        const isToday = d.date === todayIso;
                        const h = d.hours || 0;
                        const pct = (h / max) * 100;
                        return (
                            <div key={d.date} className="flex-1 flex flex-col items-center gap-1">
                                <div className="w-full flex-1 flex items-end">
                                    <div
                                        className="w-full rounded-t-md transition-all"
                                        style={{
                                            height: `${pct}%`,
                                            minHeight: h > 0 ? "6px" : "2px",
                                            background: isToday
                                                ? "var(--km-green)"
                                                : "var(--km-navy-l)",
                                            border: isToday ? "none" : "1px solid var(--line-1)",
                                            borderBottom: "none",
                                        }}
                                    />
                                </div>
                                <div className={`text-[10px] uppercase font-bold ${isToday ? "text-forest" : "text-muted"}`}>
                                    {new Date(d.date + "T00:00").toLocaleDateString("en-AU", { weekday: "short" })[0]}
                                </div>
                                <div className="num text-[10px] text-muted">{h.toFixed(1)}</div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="eyebrow mt-8 mb-3">Today so far</div>
            <ul className="space-y-2">
                {entries.slice(0, 8).map((e) => (
                    <li key={e.id} className="km-card p-3 flex items-center gap-3">
                        <div className="km-chip km-chip-navy">{e.work_type}</div>
                        <div className="flex-1 min-w-0 text-sm truncate">
                            {e.unallocated_address || `Job ${(e.job_id || "").slice(0, 8)}`}
                        </div>
                        <div className="num text-sm text-ink">{(e.duration_hrs || 0).toFixed(1)}h</div>
                    </li>
                ))}
                {!entries.length && (
                    <li className="text-sm text-muted text-center py-6">Nothing stopped yet today.</li>
                )}
            </ul>

            <div className="km-card p-4 mt-6 text-sm text-muted text-center">
                Want to see the whole week? Open KMSurveys on your computer.
            </div>
        </div>
    );
}
